module.exports = __webpack_public_path__ + "4a90bebb056bf967f34a1eafe859f6f0.jpg";